import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { FiCheck, FiX } from "react-icons/fi";
import { FaXmark } from "react-icons/fa6";

import goodLit from "../../assets/images/guidelines/good-lit.webp";
import goodBg from "../../assets/images/guidelines/good-bg.webp";
import goodFrame from "../../assets/images/guidelines/good-frame.webp";
import goodAngle from "../../assets/images/guidelines/good-angle.webp";
import badLit from "../../assets/images/guidelines/bad-lit.webp";
import badBg from "../../assets/images/guidelines/bad-bg.webp";
import badFrame from "../../assets/images/guidelines/bad-frame.webp";
import badBlur from "../../assets/images/guidelines/bad-blur.webp";

const DO_ITEMS = [
  { image: goodLit, label: "Well-lit" },
  { image: goodBg, label: "Neutral background" },
  { image: goodFrame, label: "Fills the frame" },
  { image: goodAngle, label: "Straight-on angle" },
];

const DONT_ITEMS = [
  { image: badLit, label: "Dim or dark" },
  { image: badBg, label: "Busy background" },
  { image: badFrame, label: "Product too small" },
  { image: badBlur, label: "Blurry or filtered" },
];

const InvalidImageModal = ({
  isOpen,
  toggle,
  rejectionReason,
  message,
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={toggle}
      centered
      scrollable
      size="lg"
      dialogClassName="invalid-image-modal"
      contentClassName="invalid-image-modal-content"
    >
      <Modal.Body>
        <div className="invalid-image-header">
          <h4 className="invalid-image-title">
            We couldn't use this image
          </h4>
          <button
            type="button"
            className="invalid-image-close"
            onClick={toggle}
            aria-label="Close"
          >
            <FiX />
          </button>
        </div>

        <div className="invalid-image-reason">
          <div className="invalid-image-reason-label">
            Reason
          </div>
          <div className="invalid-image-reason-text">
            {rejectionReason ||
              message ||
              "The image doesn't look like a valid product photo for the selected category."}
          </div>
        </div>

        <div className="invalid-image-guidelines">
          <div className="invalid-image-guidelines-heading">
            Photo guidelines
          </div>
          <div className="invalid-image-row invalid-image-row-do">
            <div className="invalid-image-row-title">
              <FiCheck /> Do
            </div>
            <div className="invalid-image-row-items">
              {DO_ITEMS.map((item) => (
                <div key={item.label} className="invalid-guide-item">
                  <div className="invalid-guide-thumb">
                    <img src={item.image} alt={item.label} />
                  </div>
                  <div className="invalid-guide-label">{item.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="invalid-image-row invalid-image-row-dont">
            <div className="invalid-image-row-title">
              <FaXmark /> Avoid
            </div>
            <div className="invalid-image-row-items">
              {DONT_ITEMS.map((item) => (
                <div key={item.label} className="invalid-guide-item">
                  <div className="invalid-guide-thumb">
                    <img src={item.image} alt={item.label} />
                  </div>
                  <div className="invalid-guide-label">{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="invalid-image-actions">
          <Button className="invalid-image-cta" onClick={toggle}>
            Okay, I understand
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InvalidImageModal;
